import React from 'react';
import { Link } from 'gatsby';
import '../../styles/scss/style.scss';

export const Feature = () => {
  return (
    <div className="animated bounce feature feature-2" style={{ marginTop:"10rem" }}>
      <div className="feature__wrap">
        <div className="feature__left">
          <img
            src={require('../../components/images/looprobust.png')}
            alt="loop design ui kit"
            className="feature__img"
          />
        </div>
        <div className="feature__right">
          <h2 className="feature__lead feature__lead--1 showcase__lead">
            Robust UI Collection and Variants
          </h2>
          <p className="feature__text">
            Loop Pro X comes with a large collection of components which can be used to create
             any webpage and a lot of useful overrides and variants for customizing components
           </p>
          
          <br />
          
          <Link
            to="https://www.figma.com/proto/VgccgKbbxDwXrqMSTJS842/Loop-Pro-X?node-id=201%3A32&viewport=297%2C200%2C0.02586517482995987&scaling=scale-down"
            target="blank" className="btn1">
            Preview
          </Link>
        </div>
      </div>
    </div>
  );
};
